import { queryOptions, useQuery } from "@tanstack/react-query";
import type { ActivePlan } from "./types";
import { api } from "@/lib/http";

export type UserPlan =
  | {
      status: "logged_out";
      info: null;
    }
  | {
      status: "free_plan_expired";
      info: null;
    }
  | {
      status: "ok";
      info: ActivePlan;
    };

async function getUserPlan(): Promise<UserPlan> {
  const res = await api.payment.get<ActivePlan>("v1/plans/my_plan", {
    throwHttpErrors: false, // we're handling them by hand
  });
  if (res.status === 200) {
    return {
      status: "ok",
      info: await res.json(),
    };
  } else if (res.status === 418) {
    return {
      status: "free_plan_expired",
      info: null,
    };
  } else return { status: "logged_out", info: null };
}

export const userPlanQueryOptions = queryOptions({
  queryKey: ["user", "plan"],
  queryFn() {
    return getUserPlan();
  },
});

export function useUserPlan() {
  return useQuery(userPlanQueryOptions);
}
